import React from 'react';
import RangeGauge from 'ui/RangeGauge';

const FillerWordUsageModule = ({
  assessmentData,
  assessmentError,
  componentIndex,
}) => {
  const between = (x, min, max) => {
    return x >= min && x <= max;
  };

  const invalidFillerWords =
    !assessmentData?.formattedAssistedGrade?.fillerWordsPerc &&
    assessmentData?.formattedAssistedGrade?.fillerWordsPerc !== 0 &&
    !assessmentData?.formattedAssistedGrade?.interjectionsPerc &&
    assessmentData?.formattedAssistedGrade?.interjectionsPerc !== 0;

  const calculatedFillerWords = Math.round(
    assessmentData?.formattedAssistedGrade?.fillerWordsPerc +
      assessmentData?.formattedAssistedGrade?.interjectionsPerc,
  );

  const fillerWordUsageQualitativeValue = () => {
    if (between(calculatedFillerWords, 0, 5)) {
      return t('automated_analysis.filler_words.good');
    }
    if (between(calculatedFillerWords, 6, 10)) {
      return t('automated_analysis.filler_words.can_be_better');
    }
    if (between(calculatedFillerWords, 11, 100)) {
      return t('automated_analysis.filler_words.too_many');
    }
    return null;
  };

  return (
    <RangeGauge
      ranges={[
        {
          type: 'safe',
          width: 33,
          startingThreshold: 0,
          endingThreshold: 5,
        },
        {
          type: 'caution',
          width: 33,
          startingThreshold: 6,
          endingThreshold: 10,
        },
        {
          type: 'danger',
          width: 33,
          startingThreshold: 11,
          endingThreshold: 100,
        },
      ]}
      value={calculatedFillerWords}
      overallEndThreshold={100}
      componentIndex={componentIndex}
      qualitativeValue={fillerWordUsageQualitativeValue()}
      quantitativeValue={
        assessmentData.assistedGradingStatus === 'complete' &&
        !invalidFillerWords &&
        !assessmentError &&
        `${calculatedFillerWords}%`
      }
      tooltipText={t('automated_analysis.filler_words.tooltip_grading_station')}
      featureName={t('automated_analysis.filler_words.usage')}
      rangesCanBeRendered={
        assessmentData.assistedGradingStatus === 'complete' ||
        !invalidFillerWords
      }
      status={assessmentData.assistedGradingStatus}
      error={assessmentError}
      invalidValue={invalidFillerWords}
    />
  );
};

export default FillerWordUsageModule;
